module.exports = __webpack_public_path__ + "static/img/seventh_bg.df946a6c.jpg";